import { JobTitle } from '@connect-x-app/shared-domain-models';
import { ALL_SYSTEM_MESSAGES_FUNCTIONS, ReceiverOptions } from '@connect-x-app/shared-view-models';

export const determineSystemMessageReceiver = (recipients: JobTitle[] | undefined | null): ReceiverOptions => {
  if (!recipients || recipients.length === 0) {
    return ReceiverOptions.NO_FUNCTIONS;
  }

  if (ALL_SYSTEM_MESSAGES_FUNCTIONS.every(title => recipients.includes(title))) {
    return ReceiverOptions.ALL_FUNCTIONS;
  }

  return ReceiverOptions.SPECIFIC_FUNCTIONS;
};
